import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { loginAlmaTunnus } from '../../user/almalogin/almaUserActions'
import useClickAway from '../../hooks/useClickAway'
import './loginPromptBubble.pcss'

const LoginPromptBubble = ({ message, onDismiss, dispatch }) => {

  const bubbleRef = useRef(null)

  useClickAway(bubbleRef, onDismiss)

  const handleClick = () => {
    dispatch(loginAlmaTunnus())
    onDismiss()
  }

  return (
    <button
      type='button'
      className='login-prompt-bubble'
      onClick={ handleClick }
      ref={ bubbleRef }
    >
      { message }
    </button>
  )
}

LoginPromptBubble.propTypes = exact({
  message: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
})

export default LoginPromptBubble
